import * as React from 'react'
import './Header'
import './Footer'
import './Grid'
import { BuilderComponent } from '@builder.io/react'

export const LayoutBlock = () => (
  <BuilderComponent modelName='components' />
)
